module.exports = __webpack_public_path__ + "ed37296b1c3600a80a63d45df77c5134.svg";